import { defaultColumns, defaultSort } from '../../components/sales/customerReturnOrders/columns';

export default {
  state: {
    customerReturnOrders: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    customerReturnOrders: state => state.customerReturnOrders,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setCustomerReturnOrders(state, customerReturnOrders) {
      state.customerReturnOrders = customerReturnOrders;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/customer-return-order-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'customer-return-order-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const customerReturnOrders = await axios.get('api/customer-return-orders' + (query || ''));
        commit('setCustomerReturnOrders', customerReturnOrders);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/customer-return-orders/${id}`);
    },
    async search({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/customer-return-orders/search' + (queryString || ''));
      } catch (e) {
      }
    },
    async create({ commit }, payLoad) {
      await axios.post('api/customer-return-orders', payLoad);
    },
    async send({ commit }, id) {
      return await axios.post(`api/customer-return-orders/send/${id}`);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/customer-return-orders', payLoad);
    },
    async cancel({ commit }, id) {
      return await axios.post(`api/customer-return-orders/cancel/${id}`);
    },
    async undoCancel({ commit }, id) {
      return await axios.post(`api/customer-return-orders/undo-cancel/${id}`);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/customer-return-orders/${id}`);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/customer-return-order-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'CustomerReturnOrders'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
